<template>
    <v-container fluid px-3 pt-3>
        <v-row>
            <v-col cols="12">
                <h4 style="text-align:center;">All certificate purchases ordered and paid for in the VSS Portal system are final.<br>
                    <b style="color:red;font-size:large;">There will be no refunds issued for certificates purchased in the VSS Portal.</b><br>
                </h4>
            </v-col>
            <v-col cols="12">
                <b>NUMBER OF Certificates:</b> {{(parseInt(numberOfCertificates) || 0)}}
            </v-col>
            <v-col cols="12">
                <b>CHARGE PER Certificate:</b> ${{certCost}}
            </v-col>
            <v-col cols="12" v-if="showAddCost">
                <b>CHARGE PER ADDITIONAL Certificates:</b> ${{certAddCost}}
            </v-col>
        </v-row>
        <v-row v-if="includeAffs">
            <v-col cols="12">
                <b>NUMBER OF Affidavits:</b> {{(parseInt(numberOfAffidavits) || 0)}}
            </v-col>
            <v-col cols="12">
                <b>CHARGE PER Affidavit:</b> ${{affCost}}
            </v-col>
            <v-col cols="12" v-if="showAffAddCost">
                <b>CHARGE PER ADDITIONAL Affidavits:</b> ${{affAddCost}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <b>SUBTOTAL:</b> {{prettySubtotal}}
            </v-col>
            <v-col cols="12">
                <b>PROCESSING FEE ({{prettyFee}}):</b> {{prettyProcessingFee}}
            </v-col>
            <v-col cols="12">
                <b>TOTAL CHARGE:</b> {{prettyTotal}}
            </v-col>
            <v-col cols="12">
                <h4>Please Note: Once a certificate has been submitted, you will be sent to the payment screen for payment processing.
                    Once this is complete the payment cannot be refunded. Please ensure you have the correct information before submitting.</h4>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import certService from '@/services/certificateService'
import Vue from 'vue'
import paymentService from '@/services/paymentService'

export default {
    props: {
        numberOfCertificates: null,
        numberOfAffidavits: null
    },
    data: () => {
        return {
            numCerts: 0,
            numAffidavits: 0,
            subtotalData: 0,
            prettySubtotal: null,
            prettyProcessingFee: null,
            processingFee: null,
            prettyTotal: null,
            total: null,
            isLoading: false,
            paymentId: null,
            costTable: null,
            affCostTable: null,
            certCost: null,
            certAddCost: null,
            affCost: null,
            affAddCost: null,
            showAddCost: false,
            showAffAddCost: false,
            subtotalCert: 0,
            subtotalAff: 0,
            modType: null,
            includeAffs: false
        }
    },
    mounted () {
    },
    watch: {
        numberOfCertificates: function (val) {
            this.numOfCertCalc(val)
        },
        numberOfAffidavits: function (val) {
            this.numOfAffidavitCalc(val)
        }
    },
    computed: {
        prettyFee () {
            return paymentService.PaymentFee * 100 + '%' + ' or $1 minimum'
        }
    },
    methods: {
        numOfCertCalc (numOfCert) {
            let parsedNum = parseInt(numOfCert) || 0
            if (parsedNum >= 0) {
                certService.getCost(this.$http, this.modType, parsedNum, '1').then(response => {
                    this.subtotalCert = response.data
                    this.calculateTotals()
                })
            }
        },
        numOfAffidavitCalc (numOfAff) {
            let parsedNum = parseInt(numOfAff) || 0
            if (parsedNum >= 0) {
                certService.getCost(this.$http, '10', parseInt(parsedNum), '6').then(response => {
                    this.subtotalAff = response.data
                    this.calculateTotals()
                })
            }
        },
        submit (certId) {
            // go and get payment with cert id and mod type, if exists, simply emit submit, otherwise insert cert payment
            paymentService.getPaymentByCert(this.$http, certId, this.modType).then(response => {
                if (response.data) {
                    var paymentDto = response.data
                    var paymentId = paymentDto.portalPaymentId
                    paymentService.getPaymentStatus(this.$http, paymentId).then(response2 => {
                        this.paymentStatusDto = response2.data
                        if (this.paymentStatusDto.portalPaymentStatusId === 4) {
                            // if payment is complete then update status
                            certService.updateStatus(this.$http, certId, this.modType).then(() => {
                                this.$emit('resubmit')
                            })
                        } else {
                            var numberOfItems = parseInt(this.numberOfCertificates)
                            if (this.includeAffs && this.numberOfAffidavits !== null) {
                                numberOfItems += parseInt(this.numberOfAffidavits)
                            }

                            if (this.total !== paymentDto.totalCost || numberOfItems !== paymentDto.numberOfItems) {
                                paymentDto.certificateId = certId
                                paymentDto.moduleType = this.modType
                                paymentService.insertCertPayment(this.$http, paymentDto).then(response => {
                                    this.paymentId = response.data
                                    this.$emit('submit', this.paymentId)
                                })
                            } else {
                                this.$emit('submit', paymentId)
                            }
                        }
                    })
                } else {
                    var paymentDto2 = {
                        CertificateId: certId,
                        ModuleType: this.modType
                    }
                    paymentService.insertCertPayment(this.$http, paymentDto2).then(response => {
                        this.paymentId = response.data
                        this.$emit('submit', this.paymentId)
                    })
                }
            })
        },
        calculateTotals () {
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
            })

            this.subtotalData = this.subtotalCert + this.subtotalAff
            this.prettySubtotal = formatter.format(this.subtotalData)
            this.processingFee = this.subtotalData * paymentService.PaymentFee
            if (this.processingFee < paymentService.MinimumFee) {
                this.processingFee = paymentService.MinimumFee
            }
            this.prettyProcessingFee = formatter.format(this.processingFee)
            this.total = this.subtotalData + this.processingFee
            this.prettyTotal = formatter.format(this.total)
        },
        setup (modType) {
            this.modType = modType
            this.includeAffs = this.modType == '10'
            certService.getCostTable(Vue.prototype.$http, this.modType, '1').then(response => {
                this.costTable = response.data
                this.certCost = this.costTable.cost + this.costTable.childrensTrustFundAmount + this.costTable.indigentBurialFundAmount
                this.certAddCost = this.costTable.additionalCopyCost ? this.costTable.additionalCopyCost + this.costTable.childrensTrustFundAmount + this.costTable.indigentBurialFundAmount : this.certCost
                this.showAddCost = this.certCost !== this.certAddCost
            })
            if (this.includeAffs) {
                certService.getCostTable(Vue.prototype.$http, '10', '6').then(response => {
                    this.affCostTable = response.data
                    this.affCost = this.affCostTable.cost + this.affCostTable.childrensTrustFundAmount + this.affCostTable.indigentBurialFundAmount
                    this.affAddCost = this.affCostTable.additionalCopyCost ? this.affCostTable.additionalCopyCost + this.affCostTable.childrensTrustFundAmount + this.affCostTable.indigentBurialFundAmount : this.affCost
                    this.showAffAddCost = this.affCost !== this.affAddCost
                })
            }
            //default to 1 cert
            this.numOfCertCalc(1)
        }
    }
}
</script>
